// extracted by mini-css-extract-plugin
export default {"caption":"index_caption_TsPXW","picTxt":"index_picTxt_9u40I","abstract":"index_abstract_DBCI0","box_pic":"index_box_pic_ItvXb clearfix"};